import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
export interface InsightsQuery {
  [key: string]: string;
}
export function insightsRequest<T = any>(
  user: AppUser,
  part = '',
  query: InsightsQuery = {},
  method: 'get' | 'post' | 'put' | 'patch' | 'delete' = 'get',
  body?: any
): Promise<T> {
  return axios({
    method,
    url: `${window.apiBase}/i/schools/${user.activeSchoolId}/slt/insights${part ? '/' + part : ''}`,
    headers: { usid: user.roleSessionKey },
    params: query,
    ...(body === undefined ? {} : { data: body })
  }).then(response => response.data);
}
export const insightsError = error =>
  (error && error.response && error.response.data && error.response.data.details && error.response.data.details.text) ||
  'This selection could not be loaded. Please retry.';

export function savedViewsRequest(
  user: AppUser,
  part = '',
  method: 'get' | 'post' | 'patch' | 'delete' = 'get',
  body?: any
): Promise<any> {
  return axios({
    method,
    url: `${window.apiBase}/i/schools/${user.activeSchoolId}/slt/views${part ? '/' + part : ''}`,
    headers: { usid: user.roleSessionKey },
    ...(body === undefined ? {} : { data: body })
  }).then(response => response.data);
}

export async function downloadParticipationSummary(user: AppUser, query: InsightsQuery, options: any) {
  try {
    const response = await axios({
      method: 'post',
      url: `${window.apiBase}/i/schools/${user.activeSchoolId}/slt/insights/participation-summary`,
      headers: { usid: user.roleSessionKey },
      params: query,
      data: options,
      responseType: 'blob'
    });
    const url = URL.createObjectURL(response.data),
      link = document.createElement('a');
    link.href = url;
    link.download = `${
      options.reportKind && options.reportKind !== 'summary' ? options.reportKind + '-report' : 'participation-summary'
    }.${options.format}`;
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    if (error?.response?.data instanceof Blob) {
      try {
        error.response.data = JSON.parse(await error.response.data.text());
      } catch (_) {}
    }
    throw error;
  }
}
